import script from "./MenuSelectedFull.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSelectedFull.vue?vue&type=script&setup=true&lang=js"

import "./MenuSelectedFull.vue?vue&type=style&index=0&id=cd5a5c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd5a5c62"]])

export default __exports__